import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"
import type { ConfigurationResponse } from "./types"

// 取得系統設定
export function getConfiguration(config: AxiosRequestConfig = {}) {
    return instance.request<ConfigurationResponse>({
        url: "/systems/configuration/",
        method: "get",
        ...config,
    })
}

// 設置系統設定
export function updateConfiguration(config: AxiosRequestConfig = {}) {
    return instance.request<ConfigurationResponse>({
        url: `/systems/configuration/`,
        method: "put",
        ...config,
    })
}
